module.exports = {
  defaultBgColor: "transparent",
  formats: {
    webp: {
      quality: 85,
      lossless: false,
    },
    png: {
      quality: 90,
      compressionLevel: 9,
    },
  },
  presets: {
    swatch: { width: 25, height: 25, bgColors: [] },
    thumbnail: { width: 50, height: 50, bgColors: [] },
    small: { width: 136, height: 167, bgColors: [] },
    galleryPreview: { width: 136, height: 136, bgColors: [] },
    medium: {
      width: 474,
      height: 474,
      bgColors: ["transparent"],
      formats: ["webp", "png"],
    },
    large: { width: 1100, height: 1100, bgColors: [] },
    newsletter: { width: 1280, height: 242, bgColors: [] },
    carousel: { width: 1280, height: 600, bgColors: [] },
    pushBlock: { width: 284, height: 353, bgColors: [] },
    siriusLogo: {
      width: 278,
      height: 114,
      bgColors: ["transparent"],
      formats: ["webp", "png"],
    },
    pushBlockWide: { width: 568, height: 353, bgColors: [] },
    cartPreview: { width: 50, height: 50, bgColors: [] },
    wishlistPreview: { width: 50, height: 50, bgColors: [] },
    widgetTextImage: { width: 780, height: 511, bgColors: [], sizes: [1] },
    footerLogo: {
      width: 305,
      height: 194,
      bgColors: ["transparent"],
      formats: ["webp", "png"],
    },
    textRightImageLeft: { width: 930, height: 340, bgColors: [] },
    textRightImageLeftCms: { width: 960, height: 370, bgColors: [] },
    certifications: {
      width: 120,
      height: 120,
      bgColors: ["transparent"],
      formats: ["webp", "png"],
    },
    certificationBigImage: { width: 930, height: 340, bgColors: [] },
    headerCategory: { width: 960, height: 314, bgColors: [] },
    productVignette: {
      width: 358,
      height: 334,
      bgColors: ["transparent"],
      formats: ["webp", "png"],
    },
    productImage: { width: 602, height: 602, bgColors: [] },
    pictoTop: { width: 87, height: 64, bgColors: [] },
    launcherImage: { width: 1528, height: 422, bgColors: [] },
    launcherImageSmall: { width: 493, height: 220, bgColors: [] },
    productSelectionWidget: { width: 351, height: 572, bgColors: [] },
  },
  extensions: [".jpg", ".jpeg", ".png", ".webp"],
};
